module.exports = __webpack_public_path__ + "static/portfolio-mas-16-aad29b87671cecb53384f57b3f79c5de.jpg";